import type { RootState } from '@/_store/store';

export const selectPlacesMinimal = (state: RootState) =>
  state.utils.placesMinimal;
